/**
 * Skeleton · EmptyState — YÜKLENİYOR ve BOŞ durumları.
 *
 * ─── NEDEN BİLEŞEN ───────────────────────────────────────────────────────────
 * Bu iki durum her listede tekrarlanır ve her seferinde elle yazılırsa bir
 * kısmı unutulur: veri gelene kadar boş ekran, ya da "kayıt yok" yerine
 * sonsuz dönen çark. İkisi de kullanıcıya sistemin bozulduğunu düşündürür.
 *
 * `EmptyState` bir EYLEM alır: boş liste çıkmazı olmamalı, kullanıcı oradan
 * ilk kaydı oluşturabilmeli ("oluşturma kolay olsun").
 */
import type { ReactNode } from 'react';

import { cx } from './cx.ts';

export function Skeleton({ className }: { readonly className?: string }): React.JSX.Element {
  return (
    <div
      className={cx('animate-pulse rounded-[var(--radius-control)] bg-surface-sunken', className)}
      aria-hidden="true"
    />
  );
}

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly icon?: ReactNode;
}

export function EmptyState({
  title,
  description,
  action,
  icon,
}: EmptyStateProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      {icon !== undefined && <div className="text-ink-muted">{icon}</div>}
      <div>
        <p className="font-medium text-ink">{title}</p>
        {description !== undefined && <p className="mt-1 text-sm text-ink-muted">{description}</p>}
      </div>
      {action}
    </div>
  );
}

/**
 * Yükleniyor listesi — kaç satırlık iskelet gösterileceği çağıranın kararı.
 * Gerçek satır sayısına yakın olmalı ki içerik gelince sayfa zıplamasın.
 */
export function SkeletonList({ rows = 3 }: { readonly rows?: number }): React.JSX.Element {
  return (
    <div className="flex flex-col gap-3" aria-busy="true" aria-live="polite">
      <span className="sr-only">Yükleniyor…</span>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-24 w-full" />
      ))}
    </div>
  );
}
